module.exports = __webpack_public_path__ + "img/co-event.c064e93c.jpg";